import AbstractApi from '@/api/abstracts/AbstractApi'
import httpClient from '@/utilities/service/httpClient'
// eslint-disable-next-line prettier/prettier
import type { ArmsPayloadType } from '@/api/types/request/ArmsPayloadType'
import type { ArmsType } from '@/api/types/response/ArmsType'

/**
 * @property string apiEnd /api/sales/bid/spec/{bidNumber}/{id}/arms
 */
export default class ArmsApi extends AbstractApi {
  add(payload: ArmsPayloadType): Promise<ArmsType> {
    return httpClient.post(this.apiEnd, payload)
  }

  delete(arm: string): Promise<ArmsType> {
    return httpClient.delete(`${this.apiEnd}/${arm}`)
  }
}
